import Vue from 'vue';

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('reports/excise_calendar')
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/exciseCalendar.js